import { appDimensions } from "config/app-constants";
import { createRef, ReactNode } from "react";
import { InternalDatalistTablePropsType } from "types/datalist-types";
import CoreComponent from "utilities/component-utilities/CoreComponent";
import { isVisible } from "utilities/datalist/datalist-utilities";
import DatalistTableHeaderItem from "./DatalistTableHeaderItem";

class DatalistStickyHeader<TItemType, TFilterType, TSortType>  extends CoreComponent<InternalDatalistTablePropsType<TItemType, TFilterType, TSortType>> {
    private tableWrapperElement: HTMLDivElement | undefined;
    private tableHeaderElement: HTMLElement | undefined;
    private tableHeaderStickyElement: HTMLDivElement | undefined | null;
    private tableHeaderStickyInnerElement: HTMLDivElement | undefined | null;
    private mainElement: HTMLElement | undefined;
    private tableHeaderStickyElementRef = createRef<HTMLDivElement>();
    private tableFooterElement: HTMLElement | undefined;
    private top: number = 0;
    private bottom: number = 0;

    componentDidMount(): void {
        this.initElements();
        this.mainElement?.addEventListener('scroll', this.onScroll);
        this.tableWrapperElement?.addEventListener('scroll', this.onScroll);
        window.addEventListener('resize', this.dimensions);
    }

    componentDidUpdate(): void {
        this.initElements();
    }

    componentWillUnmount(): void {
        super.componentWillUnmount();
        this.mainElement?.removeEventListener('scroll', this.onScroll);
        this.tableWrapperElement?.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.dimensions);
    }

    private initElements = () => {
        this.mainElement = document.getElementsByTagName('main')[0];
        this.tableHeaderStickyElement = this.tableHeaderStickyElementRef?.current;
        this.tableWrapperElement = this.tableHeaderStickyElement!.parentElement as HTMLDivElement;
        this.tableHeaderElement = this.tableWrapperElement.getElementsByTagName('thead')[0] as HTMLElement;
        this.tableHeaderStickyInnerElement = this.tableHeaderStickyElement?.children[0] as HTMLDivElement;
        this.tableFooterElement = this.tableWrapperElement.getElementsByTagName('tfoot')[0] as HTMLElement;
        this.dimensions();
    }

    private dimensions = () => {
        this.top = this.mainElement!.scrollTop + this.tableHeaderElement!.getBoundingClientRect().top;
        const left = this.tableWrapperElement!.scrollLeft + this.tableHeaderElement!.getBoundingClientRect().left;
        const width = this.tableHeaderElement!.offsetWidth;
        const height = this.tableHeaderElement!.offsetHeight;
        this.bottom = this.top + this.tableWrapperElement?.offsetHeight!;
        if(this.tableFooterElement) {
            this.bottom = (this.mainElement!.scrollTop + this.tableFooterElement!.getBoundingClientRect().top) - height;
        }
        // #region set dimensions for wrapper
        this.tableHeaderStickyElement!.style.width = `${this.tableWrapperElement?.offsetWidth}px`;
        this.tableHeaderStickyElement!.style.left = `${left}px`;
        // #endregion 
        // #region set dimensions for header
        this.tableHeaderStickyInnerElement!.style.width = `${width}px`;
        this.tableHeaderStickyInnerElement!.style.height = `${height}px`;

        this.tableHeaderStickyInnerElement?.childNodes.forEach((x, i) => {
            const element = x as HTMLElement;
            const columnElement = this.tableHeaderElement?.children[0].children[i] as HTMLElement;
            element.style.width = `${columnElement.offsetWidth}px`;
        });
        // #endregion
        this.onScroll();
    }

    private onScroll = () => {
        this.tableHeaderStickyElement!.scrollLeft = this.tableWrapperElement!.scrollLeft;
        const scrollTop = this.mainElement!.scrollTop + appDimensions.appHeaderHeight;
        let bottom = this.bottom + this.tableHeaderStickyElement!.offsetHeight;
        if(scrollTop >= this.top && scrollTop <= bottom) {
            this.tableHeaderStickyElement!.classList.remove('hidden');
            const y = this.tableFooterElement?.getBoundingClientRect().y;
            if(y !== undefined && y < this.tableHeaderStickyElement!.offsetHeight + appDimensions.appHeaderHeight) {
                this.tableHeaderStickyElement!.style.top = `${y - this.tableHeaderStickyElement!.offsetHeight}px`;
            } else {
                this.tableHeaderStickyElement!.style.top = `${appDimensions.appHeaderHeight}px`;
            }
        } else {
            this.tableHeaderStickyElement!.classList.add('hidden');
            this.tableHeaderStickyElement!.style.top = `${appDimensions.appHeaderHeight}px`;
        }
    }

    render(): ReactNode {
        return (
            <div ref={this.tableHeaderStickyElementRef} className="sticky-header-footer sticky-header hidden">
                <div className="column-wrapper flex">
                    {this.props.columns.filter(c => isVisible(c)).map(c => {
                        return <div className={`theme-bg app-label ${c.className || ''} table-column`} key={`datalist-${this.props.name}-sticky-table-header-${c.name}}`}>
                            <DatalistTableHeaderItem column={c} />
                        </div>;
                    })}
                </div>
            </div>
        );
    }
}

export default DatalistStickyHeader;
